// extracted by mini-css-extract-plugin
module.exports = {"editButton":"reviewSection_editButton__kG13x","title":"reviewSection_title__WXoMb"};